import React from 'react';

const CaseStudyContent = () => {
  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Content */}
          <div className="space-y-12">
            {/* Challenge */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">The Challenge</h2>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">
                The agency had created an overly complicated process that was frustrating the client and slowing everything down. Every time the client wanted a new feature, the agency required multiple meetings and approvals before developers could start working.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">
                Then developers had to estimate how many hours each task would take, get those hours approved, and stop working when they hit their limit - even if they were in the middle of something important.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg">
                Developers started giving inflated time estimates to avoid getting stuck, which made the client lose trust in the agency and created constant delays.
              </p>
            </div>

            {/* Solution */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">The Solution</h2>
              <p className="text-gray-700 leading-relaxed text-lg mb-6">
                I replaced the complicated process with a simple points system that made everything easier to approve, follow, measure, and understand:
              </p>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li>• Used simple point values (1, 2, 3, 5, 8) instead of confusing hour estimates</li>
                <li>• Eliminated unnecessary meetings and pre-approvals</li>
                <li>• Let developers work continuously without artificial interruptions</li>
                <li>• Measured actual time spent after work was completed, not before</li>
                <li>• Added 20% extra time automatically to cover unexpected issues</li>
                <li>• Created reliable data over time to predict future work accurately</li>
              </ul>
            </div>

            {/* Result */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">The Result</h2>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">
                The results were immediate: approvals became faster, progress increased dramatically, and the client could easily track what was happening.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">
                After just 2 months, we had solid historical data that let us make accurate predictions based on real numbers instead of inflated developer estimates. This reduced risk significantly and rebuilt the client's trust in the development process.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg">
                The client was so impressed with the improved efficiency and transparency that they tripled their budget — not because we asked, but because they finally had a system that made sense and worked for them.
              </p>
            </div>
          </div>

          {/* Visual */}
          <div className="lg:sticky lg:top-8">
            <div className="bg-white p-8 rounded-2xl shadow-sm">
              <img
                loading="lazy"
                decoding="async"
                src="/case_study_points_system.webp"
                alt="Points System Process Diagram"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudyContent;